import { applicationKeys, IApplicationKeyParams } from './applicationKeys';

export interface IDebtRegistryDebtsKeyParams extends IApplicationKeyParams {
  SSN?: string;
}

export interface IDebtRegistryConsentKeyParams extends IApplicationKeyParams {
  personID?: string;
}

export const debtRegistryKeys = {
  root: (params: IApplicationKeyParams) =>
    [...applicationKeys.root(params), 'debt registry'] as const,
  debts: (params: IDebtRegistryDebtsKeyParams) =>
    [...debtRegistryKeys.root(params), 'debts', params.SSN] as const,
  data: (params: IApplicationKeyParams) =>
    [...debtRegistryKeys.root(params), 'data'] as const,
  consent: (params: IDebtRegistryConsentKeyParams) =>
    [...debtRegistryKeys.root(params), 'consent', params.personID] as const,
  cachedConsent: (params: IDebtRegistryConsentKeyParams) =>
    [
      ...debtRegistryKeys.root(params),
      'cachedConsent',
      params.personID,
    ] as const,
};

export function parseDebtRegistryKeys<T extends keyof typeof debtRegistryKeys>(
  queryKey: ReturnType<(typeof debtRegistryKeys)[T]>,
) {
  const [, applicationID, , type] = queryKey;

  let SSN;
  let personID;
  switch (type) {
    case 'debts':
      SSN = queryKey[4];
      break;
    case 'consent':
      personID = queryKey[4];
      break;
    case 'cachedConsent':
      personID = queryKey[4];
      break;
  }

  return { applicationID, SSN, personID };
}
